/**
 * peacohrm is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 peacohrm Inc., http://www.peacohrm.com
 *
 * peacohrm is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * peacohrm is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */

import CorePages from '@/core/pages';
import AdminPages from '@/peacohrmAdminPlugin';
import PimPages from '@/peacohrmPimPlugin';
import HelpPages from '@/peacohrmHelpPlugin';
import TimePages from '@/peacohrmTimePlugin';
import LeavePages from '@/peacohrmLeavePlugin';
import OAuthPages from '@/peacohrmCoreOAuthPlugin';
import AttendancePages from '@/peacohrmAttendancePlugin';
import MaintenancePages from '@/peacohrmMaintenancePlugin';
import RecruitmentPages from '@/peacohrmRecruitmentPlugin';
import PerformancePages from '@/peacohrmPerformancePlugin';
import CorporateDirectoryPages from '@/peacohrmCorporateDirectoryPlugin';
import authenticationPages from '@/peacohrmAuthenticationPlugin';
import languagePages from '@/peacohrmAdminPlugin';
import dashboardPages from '@/peacohrmDashboardPlugin';
import buzzPages from '@/peacohrmBuzzPlugin';
import systemCheckPages from '@/peacohrmSystemCheckPlugin';
import claimPages from '@/peacohrmClaimPlugin';

export default {
  ...AdminPages,
  ...PimPages,
  ...CorePages,
  ...HelpPages,
  ...TimePages,
  ...OAuthPages,
  ...LeavePages,
  ...AttendancePages,
  ...MaintenancePages,
  ...RecruitmentPages,
  ...PerformancePages,
  ...CorporateDirectoryPages,
  ...authenticationPages,
  ...languagePages,
  ...dashboardPages,
  ...buzzPages,
  ...systemCheckPages,
  ...claimPages,
};
